import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { getBSCTxUrl } from '../../../../utils/blockchainExplorer';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #0B1122;
  color: white;
`;

const HeroSection = styled.div`
  position: relative;
  height: 260px;
`;

const HeroImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.4;
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 10;
  padding: 2.5rem;
`;

const BackButton = styled.button`
  font-size: 0.875rem;
  color: #5ce9ff;
  background: none;
  border: none;
  cursor: pointer;
  margin-bottom: 1rem;
  padding: 0;
  
  &:hover {
    text-decoration: underline;
  }
`;

const StoreTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0;
`;

const StoreDescription = styled.p`
  color: #9ca3af;
  margin-top: 0.5rem;
`;

const TraceabilityCard = styled.div`
  margin-top: 1.5rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.75rem;
  padding: 1rem;
`;

const TraceabilityTitle = styled.h4`
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
`;

const Timeline = styled.ul`
  position: relative;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  padding-left: 1.5rem;
  list-style: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const TimelineItem = styled.li`
  position: relative;
`;

const TimelineDot = styled.span`
  position: absolute;
  left: -9px;
  top: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #5ce9ff;
`;

const TimelineLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
`;

const TimelineMeta = styled.div`
  font-size: 0.75rem;
  color: #9ca3af;
`;

const TimelineLink = styled.a`
  font-size: 0.75rem;
  color: #5ce9ff;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const FiltersSection = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1.5rem 2.5rem;
  flex-wrap: wrap;
`;

const FilterSelect = styled.select`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.5rem;
  border-radius: 0.25rem;
  color: white;
  
  option {
    background: #0B1122;
    color: white;
  }
`;

const FilterLabel = styled.label`
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  
  input {
    cursor: pointer;
  }
`;

const SellerActions = styled.div`
  padding: 0 2.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  gap: 1rem;
`;

const ActionButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  padding: 0 2.5rem;
  margin-bottom: 3rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const ProductCard = styled.div`
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s;
  
  &:hover {
    border-color: #5ce9ff;
  }
`;

const ProductImage = styled.img`
  height: 160px;
  width: 100%;
  object-fit: cover;
`;

const ProductContent = styled.div`
  padding: 1rem;
`;

const ProductName = styled.h4`
  font-weight: 500;
  margin: 0;
`;

const ProductFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
`;

const ProductPrice = styled.span`
  font-size: 1rem;
`;

const ProductViewButton = styled.button`
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  cursor: pointer;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const AuctionsSection = styled.div`
  padding: 0 2.5rem 4rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const AuctionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const AuctionCard = styled.div`
  padding: 1.5rem;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: border-color 0.2s;
  
  &:hover {
    border-color: #5ce9ff;
  }
`;

const AuctionTitle = styled.h4`
  font-weight: 500;
  margin: 0;
`;

const AuctionMeta = styled.p`
  font-size: 0.875rem;
  color: #9ca3af;
  margin-top: 0.5rem;
`;

const AuctionButton = styled.button`
  margin-top: 1rem;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  background: linear-gradient(to right, #00f7d2, #5ce9ff);
  border: none;
  color: black;
  cursor: pointer;
  font-weight: 500;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 5rem 2.5rem;
  
  p {
    color: #9ca3af;
  }
`;

const StoreView = ({
  store,
  onBack,
  onProductClick,
  onAuctionClick,
  filterCategory,
  setFilterCategory,
  filterCertified,
  setFilterCertified,
  filterStock,
  setFilterStock,
  userRole,
}) => {
  const history = useHistory();
  const [products] = useState(store.products || []);
  const [auctions] = useState(store.auctions || []);

  const filteredProducts = products.filter(p => {
    if (filterCategory !== 'all' && p.category !== filterCategory) return false;
    if (filterCertified && !p.certified) return false;
    if (filterStock && !p.stock) return false;
    return true;
  });

  return (
    <PageContainer>
      <HeroSection>
        {store.coverImage && (
          <HeroImage
            src={store.coverImage}
            alt={store.name}
            onError={(e) => {
              e.target.src = 'https://images.unsplash.com/photo-1584017911766-d451b3d0e843';
            }}
          />
        )}
        <HeroContent>
          <BackButton onClick={onBack}>← Back to Stores</BackButton>
          <StoreTitle>{store.name}</StoreTitle>
          <StoreDescription>{store.shortDescription}</StoreDescription>

          {store.trace && store.trace.length > 0 && (
            <TraceabilityCard>
              <TraceabilityTitle>Traceability Timeline</TraceabilityTitle>
              <Timeline>
                {store.trace.map((ev, idx) => (
                  <TimelineItem key={idx}>
                    <TimelineDot />
                    <TimelineLabel>{ev.label || ev.type}</TimelineLabel>
                    <TimelineMeta>
                      {ev.date ? new Date(ev.date).toLocaleDateString() : ''} · {ev.actor || 'System'}
                    </TimelineMeta>
                    {ev.tx && (
                      <TimelineLink
                        href={getBSCTxUrl(ev.tx)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View on BscScan
                      </TimelineLink>
                    )}
                  </TimelineItem>
                ))}
              </Timeline>
            </TraceabilityCard>
          )}
        </HeroContent>
      </HeroSection>

      <FiltersSection>
        <FilterSelect
          value={filterCategory}
          onChange={(e) => setFilterCategory(e.target.value)}
        >
          <option value="all">All Categories</option>
          <option value="Pharma">Pharma</option>
          <option value="General">General</option>
        </FilterSelect>
        <FilterLabel>
          <input
            type="checkbox"
            checked={filterCertified}
            onChange={(e) => setFilterCertified(e.target.checked)}
          />
          Certified
        </FilterLabel>
        <FilterLabel>
          <input
            type="checkbox"
            checked={filterStock}
            onChange={(e) => setFilterStock(e.target.checked)}
          />
          In stock
        </FilterLabel>
      </FiltersSection>

      {userRole === 'seller' && (
        <SellerActions>
          <ActionButton
            onClick={() => history.push(`/createproduct?id=${store.id}`)}
          >
            + Add Product
          </ActionButton>
          <ActionButton
            onClick={() => history.push('/createauction')}
          >
            + Create Auction
          </ActionButton>
        </SellerActions>
      )}

      <ProductsGrid>
        {filteredProducts.map((p) => (
          <ProductCard
            key={p.id}
            onClick={() => onProductClick(p)}
          >
            <ProductImage
              src={p.image}
              alt={p.name}
              onError={(e) => {
                e.target.src = 'https://images.unsplash.com/photo-1584017911766-d451b3d0e843';
              }}
            />
            <ProductContent>
              <ProductName>{p.name}</ProductName>
              <ProductFooter>
                <ProductPrice>{p.price} {p.symbol || 'USDT'}</ProductPrice>
                <ProductViewButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onProductClick(p);
                  }}
                >
                  View
                </ProductViewButton>
              </ProductFooter>
            </ProductContent>
          </ProductCard>
        ))}
      </ProductsGrid>

      {auctions.length > 0 && (
        <AuctionsSection>
          <SectionTitle>Live Auctions</SectionTitle>
          <AuctionsGrid>
            {auctions.map((a) => (
              <AuctionCard
                key={a.id}
                onClick={() => onAuctionClick(a)}
              >
                <AuctionTitle>{a.title}</AuctionTitle>
                <AuctionMeta>Ends in {a.endsIn}</AuctionMeta>
                <AuctionButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onAuctionClick(a);
                  }}
                >
                  Open
                </AuctionButton>
              </AuctionCard>
            ))}
          </AuctionsGrid>
        </AuctionsSection>
      )}

      {filteredProducts.length === 0 && (
        <EmptyState>
          <p>No products found matching your filters.</p>
        </EmptyState>
      )}
    </PageContainer>
  );
};

export default StoreView;
